import { Grid, Stack, Typography } from '@mui/material';
import { HoverStyledCard } from 'components/HoweCard';
import React from 'react'
import { useSelector } from 'react-redux';

const StockPaper = ({header,stock}) => (
    <HoverStyledCard
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        py: 2,
        // backgroundColor: "primary.darker",
        backgroundColor: "warning.main",
        
      }}
      elevation={3}
    >
      <Typography color="white" sx={{ typography: {xl:"h4",lg:"h4",md:"h5",xs:"h6"} }} >
        {header}
      </Typography>
      <Typography color="white" marginTop={3} sx={{ typography: {xl:"h2",lg:"h2",md:"h3",xs:"h4"} }} >
        {stock}
      </Typography>
    </HoverStyledCard>
);
const StockStatistics = () => {
    const statistics = useSelector((state) => state.statistics.item);
    return (
      <Stack direction="column" marginTop={2}>
        <Typography variant="h4" color="text.secondary">
          Products in machine now
        </Typography>
        <Grid spacing={1} container >
          <Grid item xl={2} xs={6} md={6}>
            <StockPaper header="Total products" stock={statistics?.total_products_in_machine.toLocaleString() ?? 0}/>
          </Grid>
          <Grid item xl={2} xs={6} md={6}>
            <StockPaper header="Total price" stock={`Rs ${statistics?.price_of_total_products_in_machine.toLocaleString('en-IN', {minimumFractionDigits: 2}) ?? 0}/-`}/>
          </Grid>
        </Grid>
      </Stack>
    );
}

export default StockStatistics